<template>
        <div class="view">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'module', params: {} }">
            Module
            </v-breadcrumbs-item>
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item :to="{ name: 'moduleView', params: {} }">
              View Module
            </v-breadcrumbs-item>
          </v-breadcrumbs>

          <v-card v-if="loaded">
            <v-card-title>
              View Module
            </v-card-title>
            <v-card-text>
              <v-simple-table>
                <template v-slot:default>
                  <tbody>
                    
          <tr v-if="module.name">
            <td max-width="35%" class="text-subtitle-1">Name:</td>
            <td>{{ module.name }}</td>
          </tr>
          
          <tr v-if="module.logo_image">
            <td max-width="35%" class="text-subtitle-1">Logo Image:</td>
            <td>{{ module.logo_image }}</td>
          </tr>
          
          <tr v-if="module.path">
            <td max-width="35%" class="text-subtitle-1">Module:</td>
            <td>{{ module.path }}</td>
          </tr>
          
          <tr v-if="module.icon">
            <td max-width="35%" class="text-subtitle-1">Icon:</td>
            <td>{{ module.icon }}</td>
          </tr>
          
          <tr v-if="module.color">
            <td max-width="35%" class="text-subtitle-1">color:</td>
            <td>{{ module.color }}</td>
          </tr>
          
          <tr v-if="module.description">
            <td max-width="35%" class="text-subtitle-1">Description:</td>
            <td>{{ module.description }}</td>
          </tr>
          
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>

          <div class="d-flex justify-space-between ma-5">
            <v-btn @click="goBack">Back</v-btn>
            <v-btn @click="edit(id)" color="primary">Edit</v-btn>
            <span></span>
          </div>
      </div>
    </template>

    <script>
    import { getModule } from "@/services/module";
    

    export default {
      data() {
        return {
            id: '',
            module: {},
            loaded: false,
            relations: {}
        }
      },
      methods : {
        goBack() {
          this.$router.go(-1);
        },
        edit(id) {
          this.$router.push({ name: "moduleEdit", params: { id: id }});
        },
        setInstace() {
          this.setDependencies().then( () => {
            getModule(this.id)
            .then((response) => {
              this.module = response.data;
              this.loaded = true;
            })
            .catch( () => {
              this.addErrorMessage("Error loading module");
              this.loaded = true;
            });
          })
        },
        async setDependencies() {
          return null;
        },
        getRelationText(id, relationProperty, relationAttribute) {
          const relationList = this.relations[relationProperty];
          if (relationList) {
            const relationObj = relationList.find(r => r.id == id);
            return relationObj[relationAttribute];
          } else {
            return "";
          }
        }
      },
      created() {
        this.id = this.$route.params.id;
        this.setInstace();
        this.$emit("showParent", false);
      }
    }
    </script>
    